import { render, staticRenderFns } from "./XCardWizard.vue?vue&type=template&id=90741c36&"
import script from "./XCardWizard.vue?vue&type=script&lang=js&"
export * from "./XCardWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports